import { ContentType, SectionType } from 'types/publishedAssets';
import { LogWarning } from 'utils/loggingHelpers';
import { TextContent } from './ContentTypes/TextContent/TextContent';
import { ImageContent } from './ContentTypes/Image/ImageContent';
import { Quote } from './ContentTypes/Quote/Quote';
import { ImageGallery } from './ContentTypes/ImageGallery/ImageGallery';
import { Video } from './ContentTypes/Video/Video';
import { ContactUs } from './ContentTypes/ContactUs/ContactUs';
import { Timeline } from './ContentTypes/Timeline/Timeline';
import { ImportantDate } from './ContentTypes/ImportantDate/ImportantDate';
import { Document } from './ContentTypes/Document/Document';
import { LinkContent } from './ContentTypes/LinkContent/LinkContent';
import { ProfileCards } from './ContentTypes/ProfileCards/ProfileCards';
import { Feed } from './ContentTypes/Feed/Feed';
import { MixedList } from './ContentTypes/MixedList/MixedList';
import { FeaturedProject } from './ContentTypes/FeaturedProject/FeaturedProject';
import { NotificationSignup } from './ContentTypes/NotificationSignup/NotificationSignup';
import { Accordion } from './ContentTypes/Accordion/Accordion';
import { IFrameContent } from './ContentTypes/IFrameContent/IFrameContent';
import { MapContent } from './ContentTypes/MapContent/MapContent';

interface ContentProps {
  content: ContentType;
  section: SectionType;
  alignLeft?: boolean;
}
export function Content(props: ContentProps) {
  const { content, section, alignLeft } = props;
  switch (content.content_type) {
    case 'text_block':
      return <TextContent content={content} alignLeft={alignLeft} />;
    case 'quote':
      return <Quote content={content} />;
    case 'image':
      return <ImageContent content={content} />;
    case 'image_gallery':
      return <ImageGallery content={content} />;
    case 'video':
      return <Video content={content} />;
    case 'contact_us':
      return <ContactUs content={content} />;
    case 'timeline':
      return <Timeline content={content} />;
    case 'important_date':
      return <ImportantDate content={content} />;
    case 'document':
      return <Document content={content} />;
    case 'link':
      return <LinkContent content={content} />;
    case 'whos_listening':
      return <ProfileCards content={content} />;
    case 'notification_signup':
      return <NotificationSignup content={content} />;
    case 'feed':
      return <Feed content={content} section={section} />;
    case 'mixed_list':
      return <MixedList content={content} section={section} />;
    case 'featured_project':
      return <FeaturedProject content={content} />;
    case 'accordion':
      return <Accordion content={content} />;
    case 'iframe':
      return <IFrameContent content={content} />;
    case 'map':
      return <MapContent content={content} />;
    default:
      LogWarning(`Content type ${content.content_type} not supported`);
      return null;
  }
}
